import React, { useContext, useEffect, useState, useCallback } from "react";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import {
  StateContext as HomeStateContext,
  DispatchContext as HomeDispatchContext,
} from "bodycodi/cmap/app/components/cmap2010/home";
import { callApi } from "bodycodi/cmap/app/js/common";
import PopupHeader from "bodycodi/cmap/app/components/cmap2020/scheduleDtlHeader";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import icon_update from "bodycodi/cmap/app/img/icon_update.png";
import icon_delete from "bodycodi/cmap/app/img/icon-delete.png";
import DetailContent from "bodycodi/cmap/app/components/cmap2020/detailContent";

type EtDtlPop = {
  updateData: Function;
  refresh: number;
  setStartTime: Function;
  setEndTime: Function;
};

const EtDtlPop = ({ updateData, refresh, setStartTime, setEndTime }: EtDtlPop) => {
  const { state } = useContext(HomeStateContext);
  const { dispatch } = useContext(DispatchContext);
  const [scheduleData, setScheduleData] = useState<any>({
    ScheduleVO: {},
  });
  const [memoReadOnly, setMemoReadOnly] = useState<string>("");
  const { ScheduleVO } = scheduleData;
  const date = ScheduleVO.startDate?.split(" ")[0].split("-");
  const startTime1 = ScheduleVO.startDate?.split(" ")[1].split(":");
  const endTime1 = ScheduleVO.endDate?.split(" ")[1].split(":");

  useEffect(() => {
    callApi(
      "/cmap2020/viewEtScheduleDtl",
      {
        seqPartner: state.scheduleDtlPop.seqPartner,
        seqPartnerBranch: state.scheduleDtlPop.seqPartnerBranch,
        seqPartnerCoach: state.scheduleDtlPop.seqPartnerCoach,
        seqSchedule: state.scheduleDtlPop.seqSchedule,
        scheduleType: state.scheduleDtlPop.scheduleType,
      },
      "GET"
    ).then((res) => {
      setScheduleData({ ...scheduleData, ...res });
      setMemoReadOnly(res.ScheduleVO.memo);
    });
  }, [refresh]);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_DTL_POP", open: { scheduleDtlPop: false } });
  };

  const clickMore = () => {
    dispatch({ type: "POP_UP_OPEN", id: "ET_SELECT_POP", open: { etSelectPop: true } });
  };

  const clickUpdate = () => {
    updateData({
      scheduleType: "ET",
      seqSchedule: ScheduleVO.seqSchedule,
      center: {
        seqPartner: ScheduleVO.seqPartner,
        seqPartnerBranch: ScheduleVO.seqPartnerBranch,
        seqPartnerCoach: ScheduleVO.seqPartnerCoach,
        partnerName: ScheduleVO.partnerName,
      },
      member: { seqMember: ScheduleVO.seqMember, name: ScheduleVO.name, imgUrl: ScheduleVO.imgUrl },
      chooseDate: {
        year: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        date: parseInt(date[2], 10),
      },
      scheduleName: ScheduleVO.scheduleName,
      csDecs: ScheduleVO.memo,
    });
    setStartTime({
      ampm: startTime1[0] * 1 >= 12 ? "PM" : "AM",
      hour: startTime1[0] * 1,
      min: startTime1[1] * 1,
    });
    setEndTime({
      ampm: endTime1[0] * 1 >= 12 ? "PM" : "AM",
      hour: endTime1[0] * 1,
      min: endTime1[1] * 1,
    });

    dispatch({
      type: "POP_UP_OPEN",
      id: "EDIT_ETC_CALENDAR_POP",
      open: { editEtcCalendarPop: true },
    });
  };

  return (
    <>
      <PopupHeader
        title="기타 스케줄"
        rightIconType="more"
        onClickBack={handleClose}
        onClickRightIcon={clickMore}
      />
      <DetailContent
        data={ScheduleVO}
        type="기타"
        setScheduleData={setScheduleData}
        memoReadOnly={memoReadOnly}
        setMemoReadOnly={setMemoReadOnly}
      />
      <CommentconfirmPopWrap d={ScheduleVO} update={handleClose} clickUpdate={clickUpdate} />
    </>
  );
};

type CommentconfirmPopWrap = {
  d: any;
  update: Function;
  clickUpdate: any;
};

type CommentconfirmPop = {
  d: any;
  update: Function;
  handleClose: Function;
  clickUpdate: any;
};

function CommentconfirmPopWrap({ d, update, clickUpdate }: CommentconfirmPopWrap) {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({ type: "POP_UP_OPEN", id: "ET_SELECT_POP", open: { etSelectPop: false } });
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.etSelectPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="" onClose={handleClose} />
      {state.etSelectPop && (
        <CommentconfirmPop
          d={d}
          update={update}
          handleClose={handleClose}
          clickUpdate={clickUpdate}
        />
      )}
    </Drawer>
  );
}

function CommentconfirmPop({ d, update, handleClose, clickUpdate }: CommentconfirmPop) {
  const { dispatch } = useContext(DispatchContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);

  const deleteComment = useCallback(() => {
    callApi(`/schedule/reservation/cancel-et/${d.seqSchedule}`, {}, "PATCH").then(() => {
      homeDispatch({ type: "UPDATE_SCHDULE" });
      update();
      handleClose();
      dispatch({
        type: "UPDATE",
        data: { toast: true, toastText: "<span>기타스케줄을 삭제했습니다.</span>" },
      });
    });
  }, [d]);

  const deleteCommontAlert = useCallback(() => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: "D",
        redYn: true,
        header: "스케줄 삭제",
        body: "스케줄 삭제하시겠어요?\n 삭제하시면 복구하실 수 없습니다.",
        cancelAlert: () => {},
        closeAlert: deleteComment,
      },
    });
  }, [deleteComment]);

  return (
    <>
      <div className="comment-confirm-pop">
        <div className="btn divider" onClick={clickUpdate}>
          <img src={icon_update} alt="" />
          수정
        </div>
        <div className="btn" onClick={deleteCommontAlert}>
          <img src={icon_delete} alt="" />
          삭제
        </div>
      </div>
    </>
  );
}

export default EtDtlPop;
